import { computed, type ComputedRef } from 'vue'
import { BookingStatus } from '@/config'
import { BookingSummary } from '@/services/BookingService.interface'
import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'
import {
  canShowPayBalanceActions,
  canShowReserveButton,
} from '@/utils/bookingFunnelNavigation'

const EMPTY_BOOKING: BookingSummary = {
  reference: '',
  extReferenceBO: '',
  packageCode: '',
  liheId: 0,
  liheName: '',
  stationName: '',
  createDate: null,
  reservedAt: null,
  activityDate: null,
  firstIresaSyncDate: null,
  lastIresaSyncDate: null,
  departureDate: '',
  returnDate: '',
  sellingPrice: 0,
  status: BookingStatus.Quote,
  travellers: [],
  options: [],
  payments: [],
  leftToPay: 0,
  createVersionDate: '',
}

export function useBookingFunnelActions(
  getBooking: () => BookingSummary | null
): {
  showReserveButton: ComputedRef<boolean>
  showPayBalanceButton: ComputedRef<boolean>
} {
  const { reserveActions } = useBookingFunnelNavigation(() => {
    return getBooking() ?? EMPTY_BOOKING
  })

  const showReserveButton = computed(() => {
    const booking = getBooking()
    if (!booking) return false
    if (!canShowReserveButton(booking)) return false
    return reserveActions.value.length > 0
  })

  const showPayBalanceButton = computed(() => {
    const booking = getBooking()
    if (!booking) return false
    if (!canShowPayBalanceActions(booking)) return false
    return reserveActions.value.some(
      action => action.kind === 'payment' || action.kind === 'balance'
    )
  })

  return { showReserveButton, showPayBalanceButton }
}
